// extracted by mini-css-extract-plugin
export default {"button":"MyButton_button__PH4Vu","button--primary":"MyButton_button--primary__9nsbh"};